import './App.css';
import AppRouter from "./AppRouter";
import {UserProvider} from "./context/UserContext";
import {ModalProvider} from "./context/ModalContext";
import Modal from "./components/Modal";
import {AppProvider} from "./context/AppContext";

function App() {
  return (
    <div className="App">
        <UserProvider>
            <AppProvider>
                <ModalProvider>
                    <Modal />
                    <AppRouter />
                </ModalProvider>
            </AppProvider>
        </UserProvider>

    </div>
  );
}

export default App;
